import { useRef } from "react";
import { motion, useMotionValue, useSpring, useScroll, useTransform, useReducedMotion } from "framer-motion";
import { Reveal } from "@/components/site/Reveal";
import { IMAGES } from "@/data/site";

export const Nostalgia = () => {
  const reduce = useReducedMotion();
  const sectionRef = useRef(null);
  const fgRef = useRef(null);

  const { scrollYProgress } = useScroll({
    target: sectionRef,
    offset: ["start end", "end start"],
  });
  const yBack = useTransform(scrollYProgress, [0, 1], reduce ? [0, 0] : [60, -60]);
  const yFront = useTransform(scrollYProgress, [0, 1], reduce ? [0, 0] : [30, -110]);

  const rx = useMotionValue(0);
  const ry = useMotionValue(0);
  const srx = useSpring(rx, { stiffness: 150, damping: 15 });
  const sry = useSpring(ry, { stiffness: 150, damping: 15 });
  const onMove = (e) => {
    if (reduce || !fgRef.current) return;
    const r = fgRef.current.getBoundingClientRect();
    const px = (e.clientX - r.left) / r.width - 0.5;
    const py = (e.clientY - r.top) / r.height - 0.5;
    ry.set(px * 12);
    rx.set(-py * 12);
  };
  const reset = () => {
    rx.set(0);
    ry.set(0);
  };

  return (
    <section
      id="nostalgia"
      data-testid="section-nostalgia"
      ref={sectionRef}
      className="bg-owo-pink py-14 md:py-24"
    >
      <div className="mx-auto max-w-[1440px] px-5 md:px-10">
        <div className="grid grid-cols-1 items-center gap-16 lg:grid-cols-12 lg:gap-10">
          <div className="lg:col-span-5">
            <Reveal>
              <span className="eyebrow" style={{ color: "#0A0A0A" }}>
                Emocje
              </span>
              <h2 className="mt-4 font-heading text-4xl font-bold leading-[1.02] tracking-tight text-ink md:text-6xl">
                Powrót do dzieciństwa
              </h2>
              <p className="mt-8 max-w-lg text-base leading-relaxed text-ink/80 md:text-lg">
                W świecie zdominowanym przez ekrany, przywracamy radość z tworzenia własnymi rękami.
                To powrót do czasów, gdy wyobraźnia była najcenniejszą zabawką.
              </p>
            </Reveal>
          </div>

          <div className="relative lg:col-span-7">
            <div className="relative mx-auto h-[420px] w-full max-w-[560px] md:h-[520px]">
              <motion.div
                style={{ y: yBack }}
                className="absolute right-0 top-0 h-[78%] w-[74%] overflow-hidden border border-white/15"
              >
                <img
                  src={IMAGES.nostalgia1}
                  alt="Dzieci bawiące się klockami"
                  className="h-full w-full object-cover"
                  loading="lazy"
                />
              </motion.div>
              <motion.div
                ref={fgRef}
                onMouseMove={onMove}
                onMouseLeave={reset}
                style={{ y: yFront, rotateX: srx, rotateY: sry, transformPerspective: 1000 }}
                className="absolute bottom-0 left-0 h-[62%] w-[58%] overflow-hidden border-4 border-white"
              >
                <img
                  src={IMAGES.nostalgia2}
                  alt="Radość wspólnego budowania"
                  className="h-full w-full object-cover"
                  loading="lazy"
                />
              </motion.div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
